import { SaveButton, differenceBetweenTwoObjects } from 'src/admin/core'
import { useFormikContext } from 'formik'
import { useUpdateProgramTrainer } from '../../hooks'
import { useAppTranslation, useNotification } from 'src/admin/core/hooks'
import { ProgramTrainer } from '../../models'

export const UpdateButton: React.FC<{
  trainer: ProgramTrainer
  afterSave?: (promise: Promise<any>, action: string) => void
}> = ({ trainer, afterSave }) => {
  const { updateProgramTrainer, loading } = useUpdateProgramTrainer()
  const form = useFormikContext()
  const { values, dirty, setSubmitting } = form
  const { label } = useAppTranslation()
  const { successNotification, errorNotification } = useNotification()

  const handleSave = () => {
    const formValues = values as ProgramTrainer
    const changes = differenceBetweenTwoObjects(formValues, trainer)

    const response = updateProgramTrainer({
      variables: {
        input: {
          id: formValues.id,
          ...changes,
        },
      },
    })
    response
      .then(() => {
        successNotification(label('DATO_ACTUALIZADO'))
      })
      .catch(() => {
        errorNotification(label('ERROR_REGISTRANDO_EL_DATO'))
      })
    if (afterSave) {
      afterSave(response, 'update')
    }
    setSubmitting(false)
  }

  return <SaveButton onClick={handleSave} isLoading={loading} disabled={!dirty} />
}
